import React from 'react';
import { Form, Input } from 'antd';
import GenericDialog from '@common/GenericDialog';

const CreatePostTestDialog = ({
                                  open,
                                  onClose,
                                  createPostTestForm,    // Ant Form instance for post-test creation
                                  onCreatePostTest,       // callback function when "Generate" is clicked
                                  GENERATE_POST_TEST_WARNING
                              }) => {
    return (
        <GenericDialog
            title="Generate post-test for this family"
            open={open}
            onClose={() => {
                // Typically we reset the form here or inside onClose in the parent
                onClose();
                createPostTestForm.resetFields();
            }}
            buttons={[
                {
                    name: 'Cancel',
                    extraProps: { type: 'text' },
                },
                {
                    name: 'Generate',
                    callback: onCreatePostTest,
                },
            ]}
        >
            {/* the original message you had in your code */}
            <p style={{ marginBottom: '12px', maxWidth: '350px' }}>
                {GENERATE_POST_TEST_WARNING}
            </p>

            {/* The form structure from your original code */}
            <Form
                className="testFamilyForm"
                form={createPostTestForm}
                initialValues={{
                    addQuestionsNow: false,
                }}
                labelCol={{ span: 8 }}
                wrapperCol={{ span: 16 }}
            >
                <Form.Item
                    label="Name"
                    name="testName"
                    rules={[
                        {
                            required: true,
                            message: 'Please input a name.',
                        },
                    ]}
                >
                    <Input placeholder="Name" />
                </Form.Item>
                <Form.Item
                    label="Description"
                    name="testDescription"
                    value="optional"
                >
                    <Input.TextArea placeholder="Description" />
                </Form.Item>
            </Form>
        </GenericDialog>
    );
};

export default CreatePostTestDialog;
